import { normalizeBP, formatDateShort } from './wellnessDisplayUtils';
import { toNumOrNull, getHrStatus, getSpo2Status, getBpStatus, getHrvStatus, getSiStatus, getRrStatus, clampScore } from './mindvaultUtils';
export function getWellnessRadarData(latest) {
        if (!latest) return [];
        return [
        { subject: 'Activity', value: clampScore(latest.activity), fullMark: 5 },
        { subject: 'Sleep', value: clampScore(latest.sleep), fullMark: 5 },
        { subject: 'Equilibrium', value: clampScore(latest.equilibrium), fullMark: 5 },
        { subject: 'Metabolism', value: clampScore(latest.metabolism), fullMark: 5 },
        { subject: 'Resilience', value: clampScore(latest.health), fullMark: 5 },
        { subject: 'Relaxation', value: clampScore(latest.relaxation), fullMark: 5 },
        ];
    }
export function getWellnessTrendData(scans) {
        if (!scans?.length) return [];
        const byDay = {};
        scans.forEach((s) => {
        const key = formatDateShort(s.created_at);
        if (!byDay[key]) byDay[key] = s;
        });

        return Object.entries(byDay)
        .map(([day, s]) => ({
            day,
            activity: clampScore(s.activity),
            sleep: clampScore(s.sleep),
            equilibrium: clampScore(s.equilibrium),
            metabolism: clampScore(s.metabolism),
            resilience: clampScore(s.health),
            relaxation: clampScore(s.relaxation),
            heartRate: Number(s.heart_rate) || 0,
            hrv: Number(s.hr_variability) || 0,
            spo2: Number(s.oxygen_saturation) || 0,
            resp: Number(s.respiration_rate) || 0,
            stress: Number(s.stress_index) || 0,
            sbp: Number(s.sbp) || 0,
            dbp: Number(s.dbp) || 0,
        }))
        .reverse();
    }
export function getVitalGraphData(scans) {
        if (!scans?.length) return [];
        return scans
            .map((s) => ({
            bloodPressure: {
                sbp: Number(s.sbp) || 0,
                dbp: Number(s.dbp) || 0,
            },
            heartRate: Number(s.heart_rate) || 0,
            hrvSdnn: Number(s.hr_variability) || 0,
            oxygenSaturation: Number(s.oxygen_saturation) || 0,
            respirationRate: Number(s.respiration_rate) || 0,
            scanDatetime: new Date(s.created_at),
            scanTime: new Date(s.created_at).toLocaleTimeString(),
            stressIndex: Number(s.stress_index) || 0,
            }))
            .reverse(); // ensure ascending by time
    }
export function getVitalCards(latest) {
        if (!latest) return [];

        const hr = toNumOrNull(latest.heart_rate);
        const spo2 = toNumOrNull(latest.oxygen_saturation);
        const rr = toNumOrNull(latest.respiration_rate);
        const hrv = toNumOrNull(latest.hr_variability);
        const sbp = toNumOrNull(latest.sbp);
        const dbp = toNumOrNull(latest.dbp);
        const si = latest.stress_index ?? null;

        return [
            {
                label: 'Heart Rate',
                value: latest.heart_rate ?? '--',
                unit: 'bpm',
                status: getHrStatus(hr),
                icon: '❤️' 
            },
            {
                label: 'Blood Pressure',
                value: normalizeBP(latest),
                unit: 'mmHg',
                status: getBpStatus(sbp, dbp),
                icon: '🩺'
            },
            {
                label: 'Oxygen Saturation',
                value: latest.oxygen_saturation ?? '--',
                unit: '%',
                status: getSpo2Status(spo2),
                icon: '💧' 
            },
            {
                label: 'Respiratory Rate',
                value: latest.respiration_rate ?? '--',
                unit: 'rpm',
                status: getRrStatus(rr),
                icon: '🫁'
            },
            {
                label: 'Stress Index',
                value: latest.stress_index ?? '--',
                unit: '',
                status: getSiStatus(si),
                icon: '😌' 
            },
            {
                label: 'HRV',
                value: latest.hr_variability ?? '--',
                unit: 'ms',
                status: getHrvStatus(hrv),
                icon: '💓' 
            },
        ];
    }
